import React, { Component } from 'react';
import MarketingTable from './Tables/MarketingTable';
import OriginalTable from './Tables/OriginalTable';
// esto es un intento de factory


class FactoryTable extends Component {

    getTable = () => {
        const { view } = this.props
        let table = <></>
        switch (view) {
            case 'quotations':
            case 'orderSales':
            case 'deliveries':
            case 'invoice':
                table = <MarketingTable
                    {...this.props}
                />
                break;

            default:
                table = <OriginalTable
                    {...this.props}
                />
                break;
        }
        return table

    }
    render() {
        return (
            this.getTable()
        );
    }
}

export default FactoryTable;
